import React from "react";
import { Card, CardMedia, CardContent, Typography, Box, Button } from "@mui/material";
import "./news.css?v=1.0";

const Welcome = () => {
 

  return (
    <Box className="news-sidebar">
        <Card className="news-card">
          <Box className="news-image-container">
            <CardMedia
              component="img"
              height="200"
              image="https://ega-senegal.com/uploads/bienvenue.jpeg"
              alt="Image de l'actualité"
              className="news-image"
            />
            <Box className="news-overlay">
              <Typography variant="h6" className="news-title">Bienvenue sur Ecunive</Typography>
              <Typography variant="body2" sx={{ whiteSpace: 'pre-line', textAlign: 'justify', textJustify: 'inter-word', hyphens: 'auto' }} className="news-description">
              <p>
                Nous sommes 😊 heureux de vous accompagner dans ce moment important de votre parcours 🎓. <br/>
                Vous êtes sur le point de commencer un nouveau chapitre 📖 !

✨ Simplifiez votre inscription universitaire en quelques clics 🖱️
 Commencez par créer un compte en quelques secondes ⏳ et accédez à plus de fonctionnalités ainsi qu'à toutes les informations dont vous avez besoin 📚. <br/>

💡 N’hésitez pas à nous contacter si vous avez des questions ❓
 Notre équipe 🤝 est là pour vous accompagner à chaque étape 🚀
</p> </Typography>
            </Box>
          </Box>
          <CardContent className="news-footer">
            <Button href="mailto:contact@ecunive.com" target="_blank" rel="noopener noreferrer" className="voir-plus-btn">
              Nous Contacter
            </Button>
          </CardContent>
        </Card>
    </Box>
  );
};

export default Welcome;
